import { render, staticRenderFns } from "./OrgHomeIntakeStats.vue?vue&type=template&id=0221eb08&scoped=true&"
import script from "./OrgHomeIntakeStats.vue?vue&type=script&lang=js&"
export * from "./OrgHomeIntakeStats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0221eb08",
  null
  
)

export default component.exports